import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Footer from '../components/Footer/Footer';
import Pagetop from '../components/Pagetop/Pagetop';
import Allprojects from '../components/Allproject/Allprojects';

class Projectpage extends Component{
    componentDidMount(){
        window.scroll(0,0)
    }
    render(){
        return(
            <div>
                <Topnavbar title="Our projects" />
                <Pagetop title="Our projects" />
                <Allprojects/>                
                <Footer/>
            </div>
        )
    }
}
export default Projectpage